import { useFeatureFlag } from '@nx/state';
import type { ReactNode } from 'react';

export const InstanceCardWrapper = ({ children, isHighlighted }: { children?: ReactNode; isHighlighted?: boolean }) => {
  const [shouldHighlightRunningInstance] = useFeatureFlag('local:highlight-running-instance');
  const highlight =
    shouldHighlightRunningInstance && Boolean(isHighlighted) ? 'border-l-8 border-l-palette-primary-bg-strong' : '';

  return (
    <div
      className={`border-palette-neutral-border-strong bg-palette-neutral-bg-weak relative shrink-0 grow basis-[136px] rounded-3xl border p-6 ${highlight}`}
    >
      {children}
    </div>
  );
};

export const InstanceCardHeader = ({ instanceName, children }: { instanceName: string; children?: ReactNode }) => {
  return (
    <div
      className="flex items-start justify-between gap-4 overflow-hidden pb-1"
      aria-label={`Instance card for ${instanceName}`}
    >
      <h5 className="w-full truncate">{instanceName}</h5>
      {children}
    </div>
  );
};
